import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { PiggyBank } from "lucide-react";

const formatCurrency = (value) => {
  return "$" + formatNumber(value);
};

const formatNumber = (value, decimals = 0) => {
  if (isNaN(value) || !isFinite(value)) {
    return decimals > 0 ? (0).toFixed(decimals) : "0";
  }
  return value.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export function ProfitSummaryCard({ results }) {
  console.log("ProfitSummaryCard results:", results);
  return (
    <Card className="shadow-md bg-gradient-to-r from-blue-50 to-indigo-50">
      <CardHeader className="p-4 sm:p-6">
        <CardTitle className="flex items-center gap-2 text-base sm:text-lg md:text-xl">
          <PiggyBank className="h-5 w-5 sm:h-6 sm:w-6 text-primary flex-shrink-0" />
          Extra Proceeds Summary
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 sm:p-6 pt-0">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
          <div className="bg-white p-3 sm:p-4 rounded-lg shadow-sm">
            <div className="text-center">
              <p className="text-xs sm:text-sm text-gray-600 mb-1">
                Total Extra Proceeds
              </p>
              <p
                className={`text-lg sm:text-xl md:text-2xl font-bold ${
                  results.totalProfit >= 0 ? "text-green-600" : "text-red-600"
                }`}
              >
                {formatCurrency(results.totalProfit)}
              </p>
            </div>
          </div>
          <div className="bg-white p-3 sm:p-4 rounded-lg shadow-sm">
            <div className="text-center">
              <p className="text-xs sm:text-sm text-gray-600 mb-1">ROI</p>
              <p
                className={`text-lg sm:text-xl md:text-2xl font-bold ${
                  results.roi >= 0 ? "text-blue-600" : "text-red-600"
                }`}
              >
                {formatNumber(results.roi, 1)}%
              </p>
            </div>
          </div>
          <div className="bg-white p-3 sm:p-4 rounded-lg shadow-sm">
            <div className="text-center">
              <p className="text-xs sm:text-sm text-gray-600 mb-1">
                Profit Margin
              </p>
              <p
                className={`text-lg sm:text-xl md:text-2xl font-bold ${
                  results.profitMargin >= 0 ? "text-purple-600" : "text-red-600"
                }`}
              >
                {formatNumber(results.profitMargin, 1)}%
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
